import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoutes = ({ children }: any): JSX.Element => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  // console.log("token Protected Routes", token);
  // console.log("location", location);
  if (!token || typeof token === "undefined") {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
return <Outlet />;
};

export default ProtectedRoutes;
